import { render, staticRenderFns } from "./StartForm2.vue?vue&type=template&id=3f8ee386&scoped=true"
import script from "./StartForm2.vue?vue&type=script&lang=ts"
export * from "./StartForm2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8ee386",
  null
  
)

export default component.exports